import {
  SLIP_DETAIL,
  SLIP_DETAIL_SUCCESS,
  SLIP_DETAIL_ERROR,
  SLIP_SELECT,
  SLIP_SELECT_SUCCESS,
  SLIP_SELECT_ERROR,
  SLIP_UPDATE,
  SLIP_UPDATE_SUCCESS,
  SLIP_UPDATE_ERROR,
  SLIP_QR_UPDATE,
  SLIP_QR_UPDATE_SUCCESS,
  SLIP_QR_UPDATE_ERROR,
} from "./actionTypes"

export const slipDetail = data => ({
  type: SLIP_DETAIL,
  payload: data
});

export const slipDetailSuccess = data => ({
  type: SLIP_DETAIL_SUCCESS,
  payload: {data}
});

export const slipDetailError = error => ({
  type: SLIP_DETAIL_ERROR,
  payload: error,
});

export const slipSelect = data => ({
  type: SLIP_SELECT,
  payload: data
});

export const slipSelectSuccess = data => ({
  type: SLIP_SELECT_SUCCESS,
  payload: {data}
});

export const slipSelectError = error => ({
  type: SLIP_SELECT_ERROR,
  payload: error,
});

export const slipUpdate = data => ({
  type: SLIP_UPDATE,
  payload: data
});

export const slipUpdateSuccess = data => ({
  type: SLIP_UPDATE_SUCCESS,
  payload: {data}
});

export const slipUpdateError = error => ({
  type: SLIP_UPDATE_ERROR,
  payload: error,
});

export const slipQRUpdate = data => ({
  type: SLIP_QR_UPDATE,
  payload: data
});

export const slipQRUpdateSuccess = data => ({
  type: SLIP_QR_UPDATE_SUCCESS,
  payload: {data}
});

export const slipQRUpdateError = error => ({
  type: SLIP_QR_UPDATE_ERROR,
  payload: error,
});
